module.exports = __webpack_public_path__ + "c0b03fee4938d45a57012831bcf978d7.svg";